module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-app"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "emails"
  }, [_c('email-list', {
    staticClass: "email-list",
    attrs: {
      "emails": _vm.emails,
      "selectedEmail": _vm.selectedEmail
    },
    on: {
      "selectAnotherMail": _vm.selectEmail
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "email-inner"
  }, [(!_vm.isComposing) ? _c('email-details', {
    attrs: {
      "email": _vm.selectedEmail
    },
    on: {
      "delete": function($event) {
        _vm.deleteEmail(_vm.selectedEmail)
      }
    }
  }) : _c('email-compose', {
    on: {
      "emailSent": _vm.sendEmail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "com"
  }, [_c('el-button', {
    staticClass: "compose",
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.composeEmail
    }
  }, [_vm._v("compose")])], 1)], 1)]), _vm._v(" "), _c('email-status', {
    attrs: {
      "emails": _vm.emails
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bafb0cd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/EmailApp.vue
// module id = 294
// module chunks = 1